
import config from "../config";
import axiosInstance, { axiosPublicInstance } from "../helpers/axiosInstance";
import { CryptoJSAesEncrypt, getDeviceId } from "../helpers/cryp";
import { deviceDetect, isDesktop, deviceType } from "react-device-detect";

const { osName } = deviceDetect();

export const doLogin = (data = {}) => {
  const staticData = {
    appCode: config().CODE.toString(),
    deviceUuid: getDeviceId(),
    deviceName: osName || "Unknown",
    deviceType: isDesktop ? "PC" : deviceType,
  };

  const postData = { ...data, ...staticData };
  const signatureString =
    postData.login +
    postData.password +
    postData.appCode +
    postData.deviceUuid +
    postData.deviceName +
    postData.deviceType +
    postData.connectionCode;

  const SIGNATURE = CryptoJSAesEncrypt(signatureString);
  return axiosInstance.post("/Membership/login", postData, {
    headers: { SIGNATURE },
  });
};

export const getUserProfile = () => {
  return axiosInstance.get("/Membership/userProfile");
};

export const doLogout = () => {
  return axiosInstance.post("/Membership/logout");
};

export const changePassword = (data) => {
  return axiosInstance.put("/Membership/changePassword", data);
};

export const editProfile = () => {
  return axiosInstance.get("/Admin/user");
};

// renewToken sadece axiosPublicInstance ile çağrılacak
export const renewToken = (data) => {
  const staticData = { appCode: config().CONNECTION_CODE };
  const postData = { ...data, ...staticData };
  const signatureString = postData.oldJwt + postData.appCode;
  const SIGNATURE = CryptoJSAesEncrypt(signatureString);

  return axiosPublicInstance.post("/Membership/renewToken", postData, {
    headers: { SIGNATURE },
  });
};

const AuthService = {
  doLogin,
  getUserProfile,
  changePassword,
  editProfile,
  doLogout,
  renewToken,
};

export default AuthService;
